/**
 * Pure function that reproduces the shadow-DOM parsing step of
 * Msg91Widget.readWidgetMobile — extracted so we can unit-test it
 * without spinning up a browser + MSG91 SDK.
 *
 * Iter-52.33 fix: never slice-and-recombine `#country-code-number-info`.
 * The old regex `/^\+(\d{1,4})/` greedy-matched 4 digits, so for a
 * valid Indian "+919212283404" it captured "+9192" as dial and then
 * appended the raw input "9212283404" → "+91929212283404". This helper
 * instead trusts the info element wholesale when it clearly contains
 * the full E.164, or hardcodes "+91" (our India-only market), then
 * HARD-validates `/^\+91\d{10}$/` before returning. Anything else is
 * rejected so the parent caches nothing — a wrong number is strictly
 * worse than no number because the Nudge feature would then WhatsApp
 * the wrong person.
 *
 * @param inputValue        raw value of `#init-contact` (may be null)
 * @param infoTextContent   textContent of `#country-code-number-info`
 * @returns validated Indian E.164 mobile ("+91XXXXXXXXXX") or null
 */
export function parseMsg91Mobile(inputValue, infoTextContent) {
  const stripCosmetic = (s) => String(s || '').replace(/\s+/g, '').replace(/[-()]/g, '');
  const rawInput = stripCosmetic(inputValue);

  let candidate = null;
  if (rawInput.startsWith('+')) {
    candidate = rawInput;
  } else {
    const infoTxt = stripCosmetic(infoTextContent);
    const infoDigits = infoTxt.startsWith('+') ? infoTxt.slice(1) : '';
    if (infoTxt.startsWith('+') && infoDigits.length >= 10 && /^\d+$/.test(infoDigits)) {
      candidate = infoTxt;
    } else if (rawInput) {
      const digitsOnly = rawInput.replace(/\D/g, '').replace(/^0+/, '');
      if (digitsOnly) candidate = '+91' + digitsOnly;
    }
  }

  if (!candidate) return null;
  if (!/^\+91\d{10}$/.test(candidate)) return null;
  return candidate;
}
